export default __webpack_public_path__ + "static/media/greenBulb.1407efd2.svg";